import { useEffect, useMemo } from "react";
import { App } from "antd";
import styles from "./style.module.scss";

function isChromeBrowser(): boolean {
  if (typeof navigator === "undefined") return true; // SSR safety

  // Prefer User-Agent Client Hints when available
  const navAny = navigator as any;
  const uaData = navAny.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    const brands: Array<{ brand: string; version: string }> = uaData.brands;
    const brandNames = brands.map((b) => (b.brand || "").toLowerCase());
    const isChrome = brandNames.some((b) => {
      const name = (b || "").toLowerCase();
      return name.includes("google chrome") || name.includes("chromium");
    });
    return isChrome;
  }

  // Fallback to userAgent sniffing
  const ua = navigator.userAgent || "";
  const isChrome = /Chrome\//.test(ua);
  const isIOSChrome = /CriOS\//.test(ua);
  return isChrome || isIOSChrome;
}

const BrowserSupportModal = () => {
  const { modal } = App.useApp();

  // Compute once on mount
  const isChrome = useMemo(() => {
    try {
      return isChromeBrowser();
    } catch (e) {
      return true; // Fail-open to avoid blocking unexpectedly
    }
  }, []);

  useEffect(() => {
    if (isChrome) return;
    modal.info({
      title: "Unsupported browser",
      content: (
        <span className={styles.message}>
          For the best experience, this application currently supports only
          <b> Google Chrome</b> desktop browser.
        </span>
      ),
      width: 520,
      closable: true,
      footer: false,
    });
  }, [isChrome, modal]);

  return null;
};

export default BrowserSupportModal;
